var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"skeleton-shimmer",style:({ height: _vm.height, width: _vm.width, borderRadius: _vm.borderRadius }),attrs:{"aria-hidden":"true","data-testid":"skeleton-shimmer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }